import {
  Component,
  inject,
  InjectionToken,
  Input,
  ViewChild,
  HostBinding,
  ChangeDetectionStrategy,
} from '@angular/core';
import { FormGroup } from '@angular/forms';
import { BaseService } from '../../model/base.service';
import { NotificationService } from '../../error/notification.service';
import { Observable } from 'rxjs';
import { MatInput } from '@angular/material/input';
import { FormName } from './form-name';

export const FORM_COMPONENT_TOKEN = new InjectionToken<FormComponent<any>>('FORM_STEPPER_TOKEN');

@Component({
  selector: 'core-form',
  template: '',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: true,
})
export abstract class FormComponent<T> {
  abstract form: FormGroup;
  abstract fields: string[];
  abstract service: BaseService<T>;

  @Input() onCancel: () => void;
  @ViewChild(MatInput) inputElement: MatInput;
  @HostBinding('class.core-form') someClass = true;

  fetchDetail: Observable<T>;

  notificationService: NotificationService = inject(NotificationService);

  patchFormWithEntity: (entity: T) => void = entity => this.form.patchValue(entity);
  formToEntity: (formGroup: FormGroup) => T = (form: FormGroup) => form.value as T;

  formName: FormName;
  isLoading: boolean = null;
  hasHeader: boolean = null;
}
